const config = {
  headers: {
    "Accept-Language": `${localStorage.getItem("lang")}`,
  },
};
export default config;
